"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Advertising = void 0;
var constants_1 = require("../constants");
var helpers_1 = require("../helpers/");
function getSectionId(sectionId) {
    if (__spreadArrays(Object.values(constants_1.OS)).some(function (value) { return sectionId.includes(value); })) {
        return sectionId;
    }
    if (sectionId.includes("_" + constants_1.PLATFORM.APP)) {
        var sectionIdWithoutApp = sectionId.replace("_" + constants_1.PLATFORM.APP, '');
        if (helpers_1.isIos()) {
            return sectionIdWithoutApp + "_" + constants_1.OS.IOS + "_" + constants_1.PLATFORM.APP;
        }
        if (helpers_1.isAndroid()) {
            return sectionIdWithoutApp + "_" + constants_1.OS.ANDROID + "_" + constants_1.PLATFORM.APP;
        }
        return sectionId;
    }
    if (helpers_1.isIos()) {
        return sectionId + "_" + constants_1.OS.IOS + "_" + constants_1.PLATFORM.WEB;
    }
    if (helpers_1.isAndroid()) {
        return sectionId + "_" + constants_1.OS.ANDROID + "_" + constants_1.PLATFORM.WEB;
    }
    if (helpers_1.isMobile()) {
        return sectionId + "_" + constants_1.DEVICE.MOBILE;
    }
    return sectionId + "_" + constants_1.DEVICE.DESKTOP;
}
var Advertising = (function () {
    function Advertising(advertising, consent, referrer) {
        if (referrer === void 0) { referrer = ''; }
        this.schedule = [
            {
                offset: 'pre',
                tag: 'placeholder_preroll',
            },
        ];
        this.admessage = '';
        this.client = 'freewheel';
        this.cuetext = 'Advertentie';
        this.vpaidcontrols = true;
        this.adblockDetection = !!advertising.adblockDetection;
        var sectionId = [
            advertising.networkGroup,
            advertising.channelGroup,
            advertising.zoneGroup,
            advertising.os,
            advertising.device,
            advertising.platform,
        ]
            .filter(function (value) { return !!value && !value.includes('retrieve'); })
            .join('_');
        this.freewheel = {
            networkid: advertising.networkId || '',
            serverid: "https://" + advertising.serverId,
            profileid: advertising.profileId || '',
            sectionid: getSectionId(sectionId),
            adManagerURL: advertising.adManagerURL || '',
            custom: {
                talpa_consent: (consent === null || consent === void 0 ? void 0 : consent.hasTalpaConsent) ? '1' : '0',
                embed_domain: referrer || '',
                _fw_gdpr_consent: (consent === null || consent === void 0 ? void 0 : consent.tcString) || '',
                _fw_gdpr: '1',
                _fw_h_user_agent: navigator.userAgent,
            },
        };
        if (typeof window.utag_data !== 'undefined' && window.utag_data.tealium_visitor_id)
            this.freewheel.custom._fw_vcid2 = window.utag_data.tealium_visitor_id;
    }
    return Advertising;
}());
exports.Advertising = Advertising;
